export default __webpack_public_path__ + "static/media/1370.d3a446d0.png";